const DEMO_SCOPE = '[data-category-market-root]'

const mapSelector = (selector: string): string => {
  const sel = selector.trim()
  if (!sel) {
    return sel
  }

  if (sel === ':root') {
    return DEMO_SCOPE
  }

  if (sel === 'html' || sel === 'body') {
    return DEMO_SCOPE
  }

  if (sel === 'html.embed') {
    return `${DEMO_SCOPE}.embed`
  }

  if (sel.startsWith('html.embed ')) {
    return `${DEMO_SCOPE}.embed ${sel.slice('html.embed '.length)}`
  }

  return `${DEMO_SCOPE} ${sel}`
}

const scopeSelectorList = (selectors: string): string => selectors.split(',').map(mapSelector).join(', ')

const scopeRuleBlock = (block: string): string =>
  block.replace(/(^|})([^@{}][^{]*)\{/g, (match, prefix, selectors) => {
    if (!selectors.trim()) {
      return match
    }

    return `${prefix}${scopeSelectorList(selectors)}{`
  })

export const scopeDemoCss = (css: string): string => {
  const output: string[] = []
  let index = 0

  while (index < css.length) {
    const mediaStart = css.indexOf('@media', index)

    if (mediaStart === -1) {
      output.push(scopeRuleBlock(css.slice(index)))
      break
    }

    if (mediaStart > index) {
      output.push(scopeRuleBlock(css.slice(index, mediaStart)))
    }

    const braceStart = css.indexOf('{', mediaStart)
    let depth = 1
    let cursor = braceStart + 1

    while (cursor < css.length && depth > 0) {
      if (css[cursor] === '{') {
        depth += 1
      }
      if (css[cursor] === '}') {
        depth -= 1
      }
      cursor += 1
    }

    const mediaBlock = css.slice(mediaStart, cursor)
    const bodyStart = mediaBlock.indexOf('{') + 1
    const bodyEnd = mediaBlock.lastIndexOf('}')
    const header = mediaBlock.slice(0, bodyStart)
    const body = mediaBlock.slice(bodyStart, bodyEnd)
    const footer = mediaBlock.slice(bodyEnd)

    output.push(`${header}${scopeRuleBlock(body)}${footer}`)

    index = cursor
  }

  return output.join('')
}
